import { FieldFilterCrop, FieldViewModel, ICropping, IFieldFilter, utils } from "../omnia"

export class FieldFilterService implements IFieldFilter {

    _fieldRegex: RegExp
    _field: string

    _cropDescrRegex: RegExp
    _cropDescr: string

    constructor(from: IFieldFilter) {

        if (from && (!from.isEmpty())) {
            this.field = from.field
            this.crop = from.crop
            this.cropDescr = from.cropDescr
            this.allYears = from.allYears
        }

    }

    get field() {
        return this._field
    }

    set field(value) {
        this._field = value
        this._fieldRegex = value ? new RegExp(utils.regexp.escape(value), "i") : undefined
    }

    get fieldRegex() {
        return this._fieldRegex
    }

    crop: FieldFilterCrop

    get cropDescr() {
        return this._cropDescr
    }

    set cropDescr(value: string) {
        this._cropDescr = value
        this._cropDescrRegex = value ? new RegExp(utils.regexp.escape(value), "i") : undefined
    }

    get cropDescrRegex() {
        return this._cropDescrRegex
    }

    allYears: boolean = false

    isEmpty() {

        return !(
            this.crop || this.field || this.cropDescr
        )

    }

}

export function applyFilter(field: FieldViewModel, filter: IFieldFilter) {

    const { fieldRegex, crop, cropDescrRegex, allYears } = filter || { fieldRegex: null, crop: null, allYears: false }

    field.croppings.forEach(c => {

        c.visible = true

        if (crop) {

            if (!(allYears || c.currentYear)) {
                c.visible = false
            }

            else if (!checkCrop(c.cropping, crop)) {
                c.visible = false
            }

        }

        if (cropDescrRegex) {
            c.visible = cropDescrRegex.test(c.cropDescription)
        }

    })

    field.visible = true

    if (fieldRegex) {
        field.visible = fieldRegex.test(field.fieldName) || fieldRegex.test(field.fieldGroup)
    }

    if (crop || cropDescrRegex) {
        field.visible = field.visible && field.croppings.some(c => c.visible)
    }

}


function checkCrop(cropping: ICropping, crop: FieldFilterCrop) {

    if (!crop) return true
    if (!cropping) return false

    const { cropId, varietyId, isVariety, name } = crop

    if ((cropId || 0) !== (cropping.CropId || 0)) {
        return false
    }

    if (!isVariety) {
        return true
    }

    return cropping.VarietyId
        ? (cropping.VarietyId === varietyId)
        : cropping.VarietyName
            ? (cropping.VarietyName === name)
            : false

}
